const vueInst = new Vue({
    el: '#vue-wrap',
    data: {
        loginFlag: 0,
        mid: null,
        mName: '',
        testForm: {
            education: '',
            major_name: '',
            seniority: '',
            phone: '',
            phoneErr: '',
        },
        successFlag: false,
        fixType: 0
    },
    methods: {
        login: function () {
            this.loginFlag = 1;
        },
        getName: function(name) {
            this.mName = name;
        },
        testSubmit: function() {
            // 手机号验证
            if (!this.isPhoneNumber(this.testForm.phone)) {
                this.testForm.phoneErr = '请输入正确的手机号码!';
                return;
            }
            axios.post(baseURL + 'addGuestman?phone=' + this.testForm.phone
                + '&education=' + this.testForm.education
                + '&major_name=' + this.testForm.major_name
                + '&seniority=' + this.testForm.seniority
                + '&mid=' + this.mid
                + '&type=2')
                .then(res => {
                    if (res.code == 200) {
                        this.successFlag = true;
                        this.testForm = {
                            education: '',
                            major_name: '',
                            seniority: '',
                            phone: '',
                            phoneErr: '',
                        };
                    }
                    if (res.code == -1) {
                        alert(res.msg);
                    }
                })
                .catch(err => console.log(err));
        },
        download: function (url) {
            if (this.loginFlag) {
                window.open(url)
            } else {
                this.goLogin()
            }
        }
    },
    mounted: function () {
        this.mid = window.mid;

        let data = document.querySelectorAll('.data');
        for (let i = 0; i < data.length; i++) {
            data[i].href = 'javascript:void(0)';
        }

        let sideHeight = document.querySelector('.side').offsetHeight
        let sideTop = document.querySelector('.side').offsetTop + document.querySelector('.home-header').offsetHeight

        if (document.querySelector('.main').offsetHeight > sideHeight) {
            window.addEventListener('scroll', () => {
                let scrollTop = document.documentElement.scrollTop;

                if (this.fixType != 0 && document.documentElement.scrollHeight - scrollTop - 354 < document.querySelector('.side').offsetHeight + 120) {
                    this.fixType = 2;
                } else if (scrollTop > sideHeight + sideTop) {
                    this.fixType = 1;
                } else {
                    this.fixType = 0;
                }
            });
        }
    }
});